<template>
  <div class="circle-detail">
    <el-card>
      <el-form ref="form" :model="formData" :rules="rules" label-width="100px">
        <!-- 圈子头像 -->
        <el-form-item label="圈子头像" prop="avatar">
          <el-upload
            class="avatar-uploader"
            :action="action"
            :show-file-list="false"
            :on-success="onAvatarUpload"
            accept="image/*"
          >
            <img v-if="formData.avatar" :src="formData.avatar" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div class="upload-tip">点击更换头像</div>
        </el-form-item>

        <!-- 添加背景图上传 -->
        <el-form-item label="背景图片" prop="bgImage">
          <el-upload
            class="bg-uploader"
            :action="action"
            :show-file-list="false"
            :on-success="onBgImageUpload"
            accept="image/*"
          >
            <div class="bg-preview" v-if="formData.bgImage">
              <img :src="formData.bgImage">
              <div class="upload-mask">
                <i class="el-icon-upload2"></i>
                <span>更换背景图</span>
              </div>
            </div>
            <div v-else class="upload-placeholder">
              <i class="el-icon-plus"></i>
              <span>上传背景图</span>
            </div>
          </el-upload>
          <div class="upload-tip">建议尺寸 1920x300，支持 jpg、png 格式</div>
        </el-form-item>

        <!-- 圈子名称 -->
        <el-form-item label="圈子名称" prop="name">
          <el-input v-model="formData.name" placeholder="请输入圈子名称"/>
        </el-form-item>

        <!-- 圈子简介 -->
        <el-form-item label="圈子简介" prop="description">
          <el-input
            type="textarea"
            v-model="formData.description"
            :rows="4"
            placeholder="请输入圈子简介"
          />
        </el-form-item>

        <!-- 加入方式 -->
        <el-form-item label="加入方式">
          <el-radio-group v-model="formData.joinType">
            <el-radio :label="0">免费加入</el-radio>
            <el-radio :label="1">付费加入</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 付费相关选项 -->
        <template v-if="formData.joinType === 1">
          <el-form-item label="加入费用" prop="price">
            <el-input-number 
              v-model="formData.price"
              :min="0"
              :precision="2"
              :step="1"
            />
          </el-form-item>

          <el-form-item label="有效期(天)" prop="validDays">
            <el-input-number 
              v-model="formData.validDays"
              :min="1"
              :step="1"
            />
          </el-form-item>
        </template>
        <el-form-item  label="是否公开" >
          <el-switch
              v-model="formData.isOpen"
              active-color="#13ce66"
              active-value="Y"
              inactive-value="N"
              inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
        <!-- 圈子频道 -->
        <el-form-item label="圈子频道">
          <div class="channel-list">
            <div 
              v-for="(item, index) in formData.channels" 
              :key="index"
              class="channel-item"
            >
              <div class="sort-btns">
                <el-button
                  type="text"
                  icon="el-icon-top"
                  @click="moveChannel(index, 'up')"
                  :disabled="index === 0"
                />
                <el-button
                  type="text"
                  icon="el-icon-bottom"
                  @click="moveChannel(index, 'down')"
                  :disabled="index === formData.channels.length - 1"
                />
              </div>
              <el-input v-model="item.name" placeholder="频道名称"/>
              <el-button 
                type="text"
                icon="el-icon-delete"
                @click="deleteChannel(index)"
              />
            </div>
            <el-button type="text" @click="addChannel">
              <i class="el-icon-plus"></i>
              添加频道
            </el-button>
          </div>
        </el-form-item>

        <!-- 自定义导航设置 -->
        <el-form-item label="自定义导航">
          <el-switch
            v-model="formData.enableCustomNav"
            active-color="#13ce66"
            inactive-color="#ff4949"
          />
        </el-form-item>
        
        <!-- 导航配置列表 -->
        <el-form-item 
          label="导航配置"
          v-if="formData.enableCustomNav"
        >
          <div class="nav-list">
            <div 
              v-for="(nav, index) in formData.navList" 
              :key="index"
              class="nav-item"
            >
              <div class="nav-inputs">
                <el-input 
                  v-model="nav.name" 
                  placeholder="导航名称"
                  class="nav-input"
                />
                <el-input 
                  v-model="nav.url" 
                  placeholder="导航链接"
                  class="nav-input"
                >
                  <template slot="prepend">http(s)://</template>
                </el-input>
              </div>
              <div class="nav-actions">
                <el-button 
                  type="text"
                  icon="el-icon-delete"
                  @click="deleteNav(index)"
                />
              </div>
            </div>
            
            <el-button 
              type="text" 
              icon="el-icon-plus"
              @click="addNav"
            >
              添加导航
            </el-button>
          </div>
        </el-form-item>
      </el-form>

      <!-- 底部按钮 -->
      <div class="action-bar">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="save">保存</el-button>
        <el-button 
          v-if="id" 
          type="danger" 
          @click="deleteCircle"
        >删除圈子</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'CircleDetail',

  data() {
    return {
      action: process.env["VUE_APP_BASE_API2"]+'/system/image/upload',
      id: '',
      formData: {
        avatar: '',
        name: '',
        description: '',
        joinType: 0,
        price: 0,
        validDays: 365,
        channels: [],
        bgImage: '',
        isOpen:'Y',
        enableCustomNav: false,
        navList: []
      },
      rules: {
        avatar: [
          { required: true, message: '请上传圈子头像' }
        ],
        name: [
          { required: true, message: '请输入圈子名称', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '请输入圈子简介', trigger: 'blur' }
        ]
      }
    }
  },

  created() {
    this.id = this.$route.query.id
    if(this.id) {
      this.loadData()
    }
  },

  methods: {
    // 加载圈子数据
    async loadData() {
      try {
        const res = await this.$http2({
          url: `/klgeek/circle/${this.id}`,
          method: 'GET'
        })
        Object.assign(this.formData, res.data)
        this.formData.navList =  JSON.parse(res.data.navList) || []
        this.formData.enableCustomNav = !!res.data.enableCustomNav
      } catch(e) {
        console.error(e)
      }
    },

    // 头像上传成功
    onAvatarUpload(res) {
      this.formData.avatar = res.data.originUrl
    },

    // 背景图上传成功
    onBgImageUpload(res) {
      this.formData.bgImage = res.data.originUrl
    },

    // 移动频道
    moveChannel(index, direction) {
      const channels = this.formData.channels
      if(direction === 'up' && index > 0) {
        // 交换位置并更新排序值
        const temp = channels[index]
        channels[index] = channels[index-1]
        channels[index-1] = temp
        channels[index].sort = index - 1
        channels[index-1].sort = index
      } else if(direction === 'down' && index < channels.length - 1) {
        // 交换位置并更新排序值
        const temp = channels[index]
        channels[index] = channels[index+1]
        channels[index+1] = temp
        channels[index].sort = index + 1
        channels[index+1].sort = index
      }
      // 强制更新视图
      this.formData.channels = [...channels]
    },

    // 添加频道
    addChannel() {
      this.formData.channels.push({
        name: '',
        sort: this.formData.channels.length + 1
      })
    },

    // 删除频道
    deleteChannel(index) {
      this.formData.channels.splice(index, 1)
      // 重新计算排序值
      this.formData.channels.forEach((channel, idx) => {
        channel.sort = idx + 1
      })
    },

    // 取消
    cancel() {
      this.$router.back()
    },

    // 保存圈子
    async save() {
      this.$refs.form.validate(async valid => {
        if (!valid) return

        try {
          if(this.id) {
            await this.$http2({
              url: `/klgeek/circle`,
              method: 'PUT',
              data: this.formData
            })
          } else {
            await this.$http2({
              url: '/klgeek/circle',
              method: 'POST', 
              data: this.formData
            })
          }
          this.$message.success('保存成功')
          this.$router.back()
        } catch(e) {
          console.error(e)
        }
      })
    },

    // 删除圈子
    deleteCircle() {
      this.$confirm('确定要删除该圈子吗?', '提示', {
        type: 'warning'
      }).then(async () => {
        try {
          await this.$http2({
            url: `/klgeek/circle/${this.id}`,
            method: 'DELETE'
          })
          this.$message.success('删除成功')
          this.$router.push("/home/community/circle-list")
        } catch(e) {
          console.error(e)
        }
      })
    },

    // 添加导航
    addNav() {
      this.formData.navList.push({
        name: '',
        url: ''
      })
    },

    // 删除导航
    deleteNav(index) {
      this.formData.navList.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.circle-detail {
  padding: 20px;
  width: 100%;
  margin: 0 auto;

  .avatar-uploader {
    text-align: center;

    .avatar {
      width: 150px;
      height: 150px;
      border-radius: 50%;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 150px;
      height: 150px;
      line-height: 150px;
      text-align: center;
      border: 1px dashed #d9d9d9;
      border-radius: 50%;
    }

    .upload-tip {
      font-size: 12px;
      color: #999;
      margin-top: 10px;
    }
  }

  .bg-uploader {
    .bg-preview {
      position: relative;
      width: 100%;
      height: 120px;
      border-radius: 4px;
      overflow: hidden;
      
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      
      .upload-mask {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background: rgba(0,0,0,0.6);
        opacity: 0;
        transition: opacity 0.3s;
        color: #fff;
        
        i {
          font-size: 24px;
          margin-bottom: 8px;
        }
        
        &:hover {
          opacity: 1;
        }
      }
    }
    
    .upload-placeholder {
      width: 100%;
      height: 120px;
      border: 1px dashed #d9d9d9;
      border-radius: 4px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      
      i {
        font-size: 24px;
        color: #8c939d;
        margin-bottom: 8px;
      }
      
      span {
        color: #8c939d;
      }
      
      &:hover {
        border-color: #409EFF;
        
        i, span {
          color: #409EFF;
        }
      }
    }
  }

  .upload-tip {
    font-size: 12px;
    color: #909399;
    margin-top: 8px;
  }

  .channel-list {
    .channel-item {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      .sort-btns {
        margin-right: 10px;
        display: flex;
        flex-direction: column;
      }

      .el-input {
        margin-right: 10px;
      }
    }
  }

  .action-bar {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 30px;
  }

  .nav-list {
    .nav-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 16px;
      
      .nav-inputs {
        flex: 1;
        display: flex;
        gap: 12px;
        
        .nav-input {
          flex: 1;
        }
      }
      
      .nav-actions {
        margin-left: 12px;
        padding-top: 8px;
      }
    }
    
    .el-button {
      margin-top: 8px;
    }
  }
}
</style> 